// @flow
// $FlowFixMe
import React, { useState, useEffect, useRef } from 'react';
import IconLabel from './IconLabel';

import styles from './EmbedCopyButton.css';
import classNames from 'classnames';
import { defineMessages, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  copied: {
    id: 'embed-copy-button.copied',
    defaultMessage: 'Embed Copied',
  },
  copy: {
    id: 'embed-copy-button.copy',
    defaultMessage: 'Embed Copy',
  },
});

type OwnProps = {
  onClick: Function,
};

type Props = OwnProps & { intl: IntlShape };

const EmbedCopyButton = ({ onClick, intl }: Props) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef();

  const onButtonClick = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    onClick();
    setCopied(true);

    timeoutRef.current = setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <button
      onClick={onButtonClick}
      className={classNames(styles.copyButton, {
        [styles.copied]: copied,
      })}
      aria-label={copied ? intl.formatMessage(messages.copied) : intl.formatMessage(messages.copy)}
    >
      {copied ? <IconLabel name="check" /> : <IconLabel name="embed" />}
    </button>
  );
};

export default injectIntl(EmbedCopyButton);
